import { useFormContext } from 'react-hook-form'

import Input from '~components/Chat/components/Input'
import { getParseBodyParams, getType } from '~components/Chat/helpers'
import { REQUIRED_VALIDATION } from '~config'

type Props = {
  dialog: Stepper
  dialogType: ApiGetStepResponse['data'][0]['type']
  index: number
  setAnswers: (answer: string) => void
  handleAnswer: Function
}

const InputText = ({
  dialog,
  dialogType,
  index,
  setAnswers,
  handleAnswer,
}: Props) => {
  const { getValues } = useFormContext()

  const answer = getType(dialog, 'input')[0]
  const parsedBodyParam = getParseBodyParams(answer)
  const id = Object.keys(parsedBodyParam)[0]

  const handleTextInputValue = (answer: Answer, id: string) => {
    const value = getValues(id)
    setAnswers(value)
    handleAnswer(answer.action, { [`${id}`]: value })
  }

  return (
    <Input
      key={dialogType + index}
      id={id}
      placeholder={answer.label}
      onSubmit={() => handleTextInputValue(answer, id)}
      validator={REQUIRED_VALIDATION}
    />
  )
}

export default InputText
